
import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle, Mail, Clock, Shield } from 'lucide-react';

export const EmailTroubleshootingTips: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const tips = [
    {
      icon: Mail,
      title: 'Check your spam folder',
      description: 'Confirmation emails sometimes end up in spam or junk mail folders.'
    },
    {
      icon: Clock,
      title: 'Wait a few minutes',
      description: 'Email delivery can take up to 5 minutes. Please be patient.'
    },
    {
      icon: Shield,
      title: 'Add us to your contacts',
      description: 'Add admin@rentflow.space to your contacts to ensure delivery.'
    }
  ];

  return (
    <div className="border border-gray-200 rounded-lg">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center space-x-2">
          <HelpCircle className="h-5 w-5 text-gray-600" />
          <span className="text-sm font-medium text-gray-900">
            Not receiving emails? Get help
          </span>
        </div>
        {isExpanded ? (
          <ChevronUp className="h-4 w-4 text-gray-600" />
        ) : (
          <ChevronDown className="h-4 w-4 text-gray-600" />
        )}
      </button>
      
      {isExpanded && (
        <div className="border-t border-gray-200 p-4 space-y-4">
          {tips.map((tip, index) => (
            <div key={index} className="flex items-start space-x-3">
              <tip.icon className="h-4 w-4 text-gray-600 mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900">{tip.title}</p>
                <p className="text-xs text-gray-600 mt-1">{tip.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
